import axios from 'axios';

const paymentHubApi = axios.create({
  baseURL: process.env.REACT_APP_PAYMENT_HUB_API_URL,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_PAYMENT_HUB_API_KEY}`,
  },
});

export default paymentHubApi;
